<!-- <router-outlet></router-outlet> -->
<div id="all" *ngIf="datas && (!isVP)" (click)="onClick()" [class]="'fullHD roboto step-'+current">
  <div *ngIf="!isVP && (current=='video' || current=='question') && currentVideo" id="video" class="fullHD" (click)="onVideoClick()">
    <video #video autoplay [src]="base+datasName+'/videos/'+currentVideo" class="fullHD" (ended)="onVideoEnded($event)" (timeupdate)="onTimeupdate($event)" [attr.loop]="loop ? 'loop' : null"></video>
    <!-- <video #video autoplay [src]="base+datasName+'/files/'+datas.video" class="fullHD" [poster]="base+'files/'+getPoster(datas.video)" (ended)="onVideoEnded($event)"></video> -->
    <!-- <div class="progressBar"><div class="progressingBar" [style.backgroundColor]="datas.color" [style.width]="videoProgress+'%'"></div></div> -->
  </div>

  <div id="splash" class="page roboto fullHD" *ngIf="current == 'splash'" (click)="onSplashClick()" [style.background]="bgImage">
    <div class="group">
      <div class="title suburban"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div>
      <div class="baseline">
        <span [innerHTML]="datas.baseline">...</span>
        <span class="picto" *ngIf="espace" [style.backgroundColor]="espace.color">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
              C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
              c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
              c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
              c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
              c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
              <path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
              c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
              c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
              c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
              c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
              c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
            </g>
          </svg>
        </span>
      </div>
    </div>
  </div>
  <div id="game" class="page roboto fullHD" *ngIf="current == 'game'">
    <div class="block block0 negative" *ngIf="step <= 3" [class.arrow]="step != 2">
      <div class="table">
        <div class="cell">
          <div *ngIf="step==1" [innerHTML]="datas.intro"></div>
          <div *ngIf="step==2 && photo1" [innerHTML]="datas.instruction_3"></div>
          <div *ngIf="step==2" [innerHTML]="'Classer'" class="savoir" (click)="onShowIA()"></div>
          <div *ngIf="step==3" [innerHTML]="datas.instruction_4"></div>
          <div *ngIf="step==3" [innerHTML]="datas.savoir_plus" class="savoir" (click)="onSavoir()"></div>
        </div>
      </div>
    </div>
    <div class="block block1" [class.center]="step >= 4">
      <div class="inner">
        <div class="table">
          <div class="cell">
            <div class="image" [style.backgroundImage]="photo0?.sanitized"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="block block2" [class.zoom]="true || step == 1 && !photo1"  *ngIf="step < 4">
      <div class="inner">
        <div class="table">
          <div class="cell">
            <div class="grid" *ngIf="step == 1 || step == 2 || step == 3">
              <div class="thumbnail" *ngFor="let m of matches; let i = index;" [class.selected]="photo1 && m.index == photo1.index" [ngStyle]="{
                'top': positions[mixer[i]].top,
                'left': positions[mixer[i]].left,
                'transition-delay': (i/10)+'s'
              }" [style.backgroundImage]="sanitizeMatch(m).sanitized" (click)="onOkSelect(m)">
                <div class="inner_thumbnail">
                  <!-- <span>{{m.index}}</span><br> -->
                  <div *ngIf="step==3" class="infos"><span [innerHTML]="rank(i)+' &nbsp;&nbsp; Δ '+m.score"></span></div>
                  <a (click)="onOkSelectConfirm(m)" *ngIf="step == 1 && photo1 && m.index == photo1.index">Ok</a>
                  <!-- <div *ngIf="photo1"><span [innerHTML]="rank(i)+' &nbsp;&nbsp; '+m.match+'%'"></span></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="legend" [innerHTML]="datas.legend_0" *ngIf="step == 3"></div>
    </div>
    <div class="block block3" *ngIf="step == 4 && photo1">
      <div class="table">
        <div class="cell">
          <div class="image" [style.backgroundImage]="photo1.sanitized">
            <div class="infos"><span [innerHTML]="'Δ '+photo1.score"></span></div>
          </div>
        </div>
      </div>
      <!-- <div class="legend" [innerHTML]="datas.legend_1"></div> -->
    </div>
    <div class="block block4" *ngIf="step == 4 && photo2">
      <div class="table">
        <div class="cell">
          <div class="image" [style.backgroundImage]="photo2.sanitized">
            <div class="infos"><span [innerHTML]="'Δ '+photo2.score"></span></div>
          </div>
        </div>
      </div>
      <!-- <div class="legend" [innerHTML]="datas.legend_2"></div> -->
    </div>
  </div>

  
  <div class="block block5 negative" *ngIf="step > 3">
    <div class="table">
      <div class="cell">
        <div [innerHTML]="datas.legend_1"></div>
      </div>
    </div>
  </div>
  <div class="block block6 negative" *ngIf="step > 3">
    <div class="table">
      <div class="cell">
        <div [innerHTML]="datas.legend_2"></div>
      </div>
    </div>
  </div>
  <div class="block block7" *ngIf="step > 3">
    <div class="table">
      <div class="cell">
        <h1 [innerHTML]="datas.conclusion_title"></h1>
        <div [innerHTML]="datas.conclusion_description"></div>
        <div class="center">
          <a (click)="onRestart()" class="btn btn_restart negative" [innerHTML]="datas.restart"></a>
        </div>
        <div [innerHTML]="datas.conclusion_description2" class="ps"></div>
      </div>
    </div>
  </div>


  <!-- ************************************ -->
  <div class="instruction fullHD absolute" *ngIf="current == 'introduction'" (click)="onInstructionClick()"  [style.background]="bgImage">
    <div class="bloc absolute">
      <div class="inner">
        <h1 [innerHTML]="datas.introduction_title" class="suburban"></h1>
        <div class="details table">
          <div class="cell" [innerHTML]="datas.introduction_description"></div>
          <div class="center">
            <a (click)="onInstructionClick()" class="next suburban">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
  </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="conclusion fullHD absolute" *ngIf="current == 'conclusion'">
    <div class="bloc absolute">
      <div class="inner">
        <div class="table">
          <div class="cell">
            <h1 [innerHTML]="datas.conclusion_title"></h1>
            <div [innerHTML]="datas.conclusion_description"></div>
            <div class="center">
              <a (click)="onRestart()" class="next suburban">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ************************************ -->

  <a class="homeBtn" (click)="goHome()">
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:#FFFFFF;}
      </style>
      <path class="st0" d="M14,15c0.28,0,0.5-0.22,0.5-0.5v-7c0-0.13-0.05-0.26-0.15-0.35l-6-6c-0.2-0.2-0.51-0.2-0.71,0l0,0l-6,6
      C1.55,7.24,1.5,7.37,1.5,7.5v7C1.5,14.78,1.72,15,2,15H14z"/>
    </svg>
  </a>

</div>
<!-- <div id="debug" [innerHTML]="step" *ngIf="true || debug"></div> -->